import React from "react";
import PropTypes from "prop-types";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import SubMenu from "./SubMenu";


class ExMenu extends React.Component {

    static propTypes = {
        open: PropTypes.bool.isRequired,
        menuItems: PropTypes.array.isRequired,
        anchorElement: PropTypes.any,
        onClose: PropTypes.func.isRequired,
        selection: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.renderMenuItems = this.renderMenuItems.bind(this);

        this.state = {
            selectedIndex: 0
        };
    }

    handleMenuItemClick(event, index, value) {
        console.log("Select index " + index + value);
        this.setState({selectedIndex: index});
    }

    renderMenuItems = () => {
        const {menuItems, selection} = this.props;
        return menuItems.map((menuItem, index) => {
            if (menuItem.hasOwnProperty("subMenuItems")) {
                return (
                    <SubMenu
                        key={menuItem.key}
                        caption={menuItem.caption}
                        menuItems={menuItem.subMenuItems}
                        selection={menuItem.selection}
                        closeCallback={this.props.onClose}
                    />
                );
            } else if (selection) {
                return (
                    <MenuItem
                        key={menuItem.key}
                        value={menuItem.value}
                        selected={index === this.state.selectedIndex}
                        onClick={event => {
                            this.handleMenuItemClick(event, index, menuItem.value);
                            menuItem.onClick(event);
                            this.props.onClose();
                        }}
                    >
                        {menuItem.caption}
                    </MenuItem>
                );
            } else {
                return (
                    <MenuItem
                        key={menuItem.key}
                        onClick={() => {menuItem.onClick();this.props.onClose()}}>
                        {menuItem.caption}
                    </MenuItem>
                );
            }

        });
    };

    render() {
        const {anchorElement, anchorOrigin, anchorPosition, transformOrigin,
            elevation, classes, open, onClose} = this.props;
        return (
            <Menu
                anchorEl={anchorElement}
                open={open}
                onClose={onClose}
                classes={classes}
                elevation={elevation}
                anchorOrigin={anchorOrigin}
                anchorPosition={anchorPosition}
                transformOrigin={transformOrigin}
            >
                {this.renderMenuItems()}
            </Menu>
        );
    }
}


export default ExMenu;